import { logHandler } from "../../../components/WConsole";
import { get } from "lodash-es";
/**
 * 检查是否显示接口调用日志面板
 * @param ctx
 * @param next
 * @returns
 */
export const wConsoleMiddleware = async (ctx, next) => {
  try {
    await next();
  } catch (error) {
    // 接口报错也也检查是否要显示
    throw error;
  } finally {
    if (ctx.response) {
      await toggleWConsoleDisplay(ctx.response, ctx);
    }
  }
};
async function toggleWConsoleDisplay(res, ctx) {
  try {
    const wDisplay = res.headers['w-display'];
    if (wDisplay === 'true') {
      var _ctx$collection;
      const tempLogInfo = {
        seqId: res.headers['w-seq-id'],
        timestamp: Number(res.headers['w-timestamp']),
        originalUrl: res.config.url,
        isExpired: false,
        pageId: ctx.pageId,
        cgiId: ctx.cgiName,
        cgiName: get(ctx.cgiInfo, 'desc') || get(ctx.cgiInfo, 'name') || ctx.cgiName,
        collectionId: ctx.collectionId,
        collectionName: (_ctx$collection = ctx.collection) === null || _ctx$collection === void 0 ? void 0 : _ctx$collection.name,
        projectId: ctx.projectId
      };
      logHandler.append(tempLogInfo);
      if (logHandler.ttlms === 0) logHandler.ttlms = res.headers['w-log-ttl'] * 1000; // in millisec;
      logHandler.display = true;
    }
  } catch (error) {
    console.warn(error);
  }
}
//# sourceMappingURL=wConsole.js.map
